import { Route } from '@angular/router';

import { MpsUser } from '../../app/models/mps-user.model';

export class MpsPermissionHelper {
  static canUserActivate(user: MpsUser, route: Route): boolean {
    // Check if route has permission requirement
    const requiredPermission = route.data?.['requiredPermission'];

    if (!requiredPermission) {
      // No permission required - allow access
      return true;
    }

    // Check if user has the required permission
    if (Array.isArray(requiredPermission)) {
      return requiredPermission.some((p: string) => user.permissions?.includes(p)) ?? false;
    }
    return user.permissions?.includes(requiredPermission) ?? false;
  }
}
